import { Component } from 'react';
/**
 * ErrorBoundary implements React's `componentDidCatch` lifecycle hook
 *
 * Further reading: https://reactjs.org/docs/react-component.html#componentdidcatch
 *
 * @public
 */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, info) {
    const {
      payload,
      log
    } = this.props;
    const {
      componentStack
    } = info;
    const loggerPayload = {
      componentStack,
      error,
      ...payload
    };
    log(loggerPayload);
  }
  render() {
    const {
      hasError
    } = this.state;
    const {
      fallback,
      children
    } = this.props;
    if (hasError) {
      if (!fallback) {
        return null;
      } else {
        return fallback;
      }
    }
    return children;
  }
}
ErrorBoundary.defaultProps = {
  fallback: null,
  payload: {}
};
export default ErrorBoundary;